import { AxiosInstance } from 'axios';
import LogRocket from 'logrocket';

import axiosInterceptorRequestAddJWT from './axiosInterceptorRequestAddJWT';
import axiosInterceptorResponseError, { dismissReconnectingToast } from './axiosInterceptorResponseError';
import axiosRetry from './axiosRetry';
import axioxInterceptorMlTraceId from './axioxInterceptorMlTraceId';

type SetupOptions = {
  retries: number;
};

const setupAxiosInstance = (axiosInstance: AxiosInstance, options: SetupOptions) => {
  LogRocket.getSessionURL((sessionUrl) => {
    if (axiosInstance.defaults?.headers?.common) {
      axiosInstance.defaults.headers.common['x-user-session-url'] = sessionUrl;
    }
  });

  axiosRetry(axiosInstance, options.retries);
  axiosInstance.defaults.timeoutErrorMessage = `Sorry, it seems like something's taking longer than usual. Please refresh the page and try again.`;
  axiosInstance.interceptors.request.use(axiosInterceptorRequestAddJWT);
  axiosInstance.interceptors.request.use(axioxInterceptorMlTraceId);
  axiosInstance.interceptors.response.use((res) => {
    // Successful response means connection is restored — dismiss any reconnecting toast.
    dismissReconnectingToast();
    return res;
  }, axiosInterceptorResponseError());

  return axiosInstance;
};

export default setupAxiosInstance;
